import Calculator from "./Calculator";

import "./styles.css";

export default function App() {
  return <Calculator />;
}
